/* Penoblo Varianten-Slider (PDP).
   Pfeile blaettern den nativen Scroll-Viewport seitenweise; sichtbar nur,
   wenn die Karten breiter sind als der Viewport. Wischen bleibt nativ. */
class PnbVcards extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.pnb-vcards__viewport');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    if (!this.viewport) return;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.page(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.page(1));
    this.viewport.addEventListener('scroll', () => this.update(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.viewport);

    // Gewaehlte Variante beim Laden horizontal in die Mitte ruecken
    // (nur scrollLeft setzen — scrollIntoView wuerde die Seite vertikal verschieben)
    const current = this.querySelector('.pnb-vcard--active');
    if (current) {
      this.viewport.scrollLeft = current.offsetLeft - (this.viewport.clientWidth - current.offsetWidth) / 2;
    }
    this.update();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  page(dir) {
    this.viewport.scrollBy({ left: dir * this.viewport.clientWidth * 0.9, behavior: 'smooth' });
  }

  update() {
    const v = this.viewport;
    const overflow = v.scrollWidth > v.clientWidth + 4;
    if (this.prevBtn) {
      this.prevBtn.hidden = !overflow;
      this.prevBtn.disabled = v.scrollLeft <= 2;
    }
    if (this.nextBtn) {
      this.nextBtn.hidden = !overflow;
      this.nextBtn.disabled = v.scrollLeft + v.clientWidth >= v.scrollWidth - 2;
    }
  }
}
if (!customElements.get('pnb-vcards')) customElements.define('pnb-vcards', PnbVcards);
